// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__YdT4C","bluebtn":"styles_bluebtn__f5nPp","darkbtn":"styles_darkbtn__TOjdd"};